module.exports = __webpack_public_path__ + "static/media/filter-down-arrow.b6deeb73.svg";